class AddOnProducts extends HTMLElement {
  constructor() {
    super();

    const enabled = this.dataset.sliderEnabled;
    enabled == "true" ? this.initSlideshowSlick() : false;
  }

  initSlideshowSlick() {
    const slideshow = this.querySelector(".slideshow");

    const prev_arrow = $(this).find(".slick-prev-custom");
    const next_arrow = $(this).find(".slick-next-custom");

    const slick_options = {
      dots: this.dataset.dots == "true" ? true : false,
      arrows: this.dataset.arrows == "true" ? true : false,
      prevArrow: prev_arrow,
      nextArrow: next_arrow,
      infinite: this.dataset.infinite == "true" ? true : false,
      slidesToShow: parseInt(this.dataset.slidesToShow),
      slidesToScroll: parseInt(this.dataset.slidesToScroll),
      autoplay: this.dataset.autoplay == "true" ? true : false,
      autoplaySpeed: this.dataset.speed,
      responsive: [
        {
          breakpoint: 1190,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    $(slideshow).slick(slick_options);

    // $(prev_arrow).hide();
    //
    // $(slideshow).on('afterChange', function(event, slick, currentSlide) {
    //     if (currentSlide === 0) {
    //       $(prev_arrow).fadeOut('fast');
    //       $(next_arrow).fadeIn('fast');
    //     }
    //     else {
    //     	$(prev_arrow).fadeIn('fast');
    //     }
    //
    //     if ($(slick.$slides[slick.$slides.length - 3]).hasClass('slick-current')) {
    //     	$(next_arrow).fadeOut('fast');
    //     } else {
    //       $(next_arrow).fadeIn('fast');
    //     }
    //   });
  }
}

customElements.define("add-on-products", AddOnProducts);
